/* This is the Firebase configuration file */

import Firebase from 'firebase'
import config from './config'

let app = Firebase.initializeApp(config)
let secondaryApp = Firebase.initializeApp(config, 'Secondary')
let db = app.database()

// create a database references
const settingsRef = db.ref('settings')
const pagesRef = db.ref('pages')
const postsRef = db.ref('posts')
const usersRef = db.ref('users')
const mediaRef = db.ref('media')
const galleriesRef = db.ref('galleries')
const testimonialsRef = db.ref('testimonials')
const propertiesRef = db.ref('properties')
const locationsRef = db.ref('locations')
const accommodationsRef = db.ref('accommodations')
const navRef = db.ref('nav')

export { postsRef, usersRef, settingsRef, pagesRef, mediaRef, navRef, galleriesRef, testimonialsRef, propertiesRef, locationsRef, accommodationsRef, secondaryApp }



// WEBPACK FOOTER //
// ./src/firebase_config/index.js